<div class="row">
    <div class="col-12">

        <h1 class="page-header"><i class="fas fa-user-friends"></i> Factores de Referencia</h1>

    </div>

</div>

        <div class="panel p-4">
            <div class="row">
                <!--diverse-->
                <div class="row mb-3 align-items-center">
                    <div class="col-12 col-md-7">

                        <ng-select [items]="dataListDiverse" [selectableGroup]="true" [hideSelected]="true"
                            bindLabel="codeName" [selectableGroup]="true" groupBy="type" [closeOnSelect]="false"
                            [dropdownPosition]="'bottom'" [multiple]="true" bindValue="code"
                            [selectableGroupAsModel]="false" (change)="onCloseNgSelectFind()"
                            placeholder="Buscar por codigo, nombre..." [(ngModel)]="txtFind" tabindex="1">
                        </ng-select>
                    </div>
                    <div class="col-12 col-md-5 d-flex justify-content-end">
                        <button type="button" class="btn btn-success btn-sm" (click)="openModalDiverse()">Agregar</button>
                    </div>

                </div>

                <div class=" mt-3">
                    <div class="table-data">
                        <table class="table table-striped  table-sm ">
                            <thead>
                                <tr>
                                    <th>Codigo</th>
                                    <th>Nombre</th>
                                    <th>Entidad</th>
                                    <th>Simbolo</th>                                    
                                    <th>Decimales</th>
                                    <th>Valor</th>
                                    <th class="text-center">Editable</th>
                                    <th><span class="d-flex justify-content-center"><i class="fa fa-cogs"></i></span>
                                    </th>
                                </tr>
                            </thead>
                            @if(dataDiverse?.length>0){
                            <tbody>
                                @for(d of dataDiverse;track $index; let idx = $index){
                                <tr>
                                    <td>{{d.code}}</td>
                                    <td>{{d.name}}</td>
                                    <td>{{d.entityType=='*'?'Todas':d.entityType}}</td>
                                    <td>{{d.unitSymbol}}</td>
                                    <td>{{d.decimalPlaces}}</td>
                                    <td>{{ d.value | number:('1.' + (d?.decimalPlaces ?? 0) + '-' + (d?.decimalPlaces ?? 0)) }}</td>
                                    <td class="text-center align-middle">
                                        <input class="form-check-input" type="checkbox" [checked]="d.isEditable" 
                                               (change)="updateDiverseCheck(d, 'isEditable', !d.isEditable)">
                                    </td>
                                     <td>
                                        <span class="d-flex justify-content-center">
                                            <button type="button" class="btn btn-outline-primary btn-xs " container="body"
                                                (click)="setFormDiverse(d)"><i
                                                    class="fa fa-pencil-alt"></i></button>&nbsp;
                                           
                                            <button type="button" class="btn btn-outline-danger btn-xs" container="body"
                                                placement="right" ngbTooltip="Eliminar" (click)="deleteDiverse(d)"><i
                                                    class="fas fa-trash"></i></button>
                                        </span>
                                    </td>

                                </tr>
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="7">{{dataDiverse?.length}} en Total</th>
                                </tr>
                            </tfoot>
                            }
                        </table>
                        @if(dataDiverse?.length===0){
                        <div class="m-l-10 mb-2">
                            <em>Sin registros</em>
                        </div>
                        }
                    </div>
                </div>


            </div>
        </div>
   



    <!--modal diverse-->

    <ng-template #modal_diverse let-c="close" let-d="dismiss" let-modal>

        <div class="modal-header">
            <h5 class="modal-title">{{modalHeaderDiverse}}</h5>
            <span (click)="d('Cross click');isNewDiverse=false" type="button"
                class="btn-close bt-xs" data-dismiss="modal" tabindex="8">

            </span>
        </div>
        <div class="modal-body">
            <div class="panel-body panel-form">
                <form [formGroup]="formDiverse">
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label">Codigo</label>
                        <div class="col-md-8">
                            <input type="text" #nameInput
                                [class.is-invalid]="formDiverse.get('code').invalid&&formDiverse.get('code').touched"
                                (click)="formDiverse.get('code').markAsUntouched();"
                                (focus)="formDiverse.get('code').markAsUntouched();" formControlName="code"
                                name="code" class="form-control" tabindex="1" />
                            @if(formDiverse.get('code')?.errors?.required && formDiverse.get('code').touched){
                            <div><small class="text-danger">Codigo es requerido.</small></div>
                            }
                        </div>
                    </div>&nbsp;
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label">Descripción</label>
                        <div class="col-md-8">
                            <input type="text" #nameInput
                                [class.is-invalid]="formDiverse.get('name').invalid&&formDiverse.get('name').touched"
                                (click)="formDiverse.get('name').markAsUntouched();"
                                (focus)="formDiverse.get('name').markAsUntouched();" formControlName="name"
                                name="name" class="form-control" tabindex="2" />
                            @if(formDiverse.get('name')?.errors?.required && formDiverse.get('name').touched){
                            <div><small class="text-danger">Nombre del factor es requerido.</small></div>
                            }
                        </div>
                    </div>&nbsp;
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label">Valor</label>
                        <div class="col-md-8">
                            <input type="text" #nameInput
                                [class.is-invalid]="formDiverse.get('value').invalid&&formDiverse.get('value').touched"
                                (click)="formDiverse.get('value').markAsUntouched();"
                                (focus)="formDiverse.get('value').markAsUntouched();" formControlName="value"
                                name="value" class="form-control" tabindex="5" appNumberFormat/>
                            @if(formDiverse.get('value')?.errors?.required && formDiverse.get('value').touched){
                            <div><small class="text-danger">Valor es requerido.</small></div>
                            }
                        </div>
                    </div>&nbsp;
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label">Decimales</label>
                        <div class="col-md-8">
                            <input type="number" min="0" max="5" step="1" value="0"
                                [class.is-invalid]="formDiverse.get('decimalPlaces').invalid&&formDiverse.get('decimalPlaces').touched"
                                (click)="formDiverse.get('decimalPlaces').markAsUntouched();"
                                (focus)="formDiverse.get('decimalPlaces').markAsUntouched();" class="form-control "
                                formControlName="decimalPlaces" name="decimalPlaces" tabindex="3"/>
                            @if(formDiverse.get('decimalPlaces')?.errors?.required && formDiverse.get('decimalPlaces').touched){
                            <div><small class="text-danger">Decimales es requerido.</small></div>
                            }
                        </div>
                    </div>&nbsp;
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label">Simbolo</label>
                        <div class="col-md-8">
                            <input type="text" #nameInput
                                [class.is-invalid]="formDiverse.get('unitSymbol').invalid&&formDiverse.get('unitSymbol').touched"
                                (click)="formDiverse.get('unitSymbol').markAsUntouched();"
                                (focus)="formDiverse.get('unitSymbol').markAsUntouched();" formControlName="unitSymbol"
                                name="name" class="form-control" tabindex="4" />
                            @if(formDiverse.get('unitSymbol')?.errors?.required && formDiverse.get('unitSymbol').touched){
                            <div><small class="text-danger">Simbolo es requerido.</small></div>
                            }
                        </div>
                    </div>&nbsp;
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label">Entidad</label>
                        <div class="col-md-8">
                            <select class="form-control form-select"
                                [class.is-invalid]="formDiverse.get('entityType').invalid&&formDiverse.get('entityType').touched"
                                (click)="formDiverse.get('entityType').markAsUntouched();"
                                (focus)="formDiverse.get('entityType').markAsUntouched();" formControlName="entityType"
                                name="entityType" tabindex="5" >
                                <option value="*" >Todas</option>
                                <option value="11">Asociación/Misión</option>
                                <option value="12">Unión</option>
                                <option value="20">Institución</option>
                                <option value="40">Educación</option>
                                <option value="50">Clinica</option>
                            </select>
                            @if(formDiverse.get('entityType')?.errors?.required && formDiverse.get('entityType').touched){
                            <div><small class="text-danger">Simbolo es requerido.</small></div>
                            }
                        </div>
                    </div>&nbsp;
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label">Editable</label>
                        <div class="col-md-8 d-flex align-items-center">
                            <div class="form-check form-switch mt-1">
                                <input class="form-check-input" type="checkbox" formControlName="isEditable" id="isEditableCheck" tabindex="6">
                                <label class="form-check-label ms-1" for="isEditableCheck">Permitir modificación en presupuesto</label>
                            </div>
                        </div>
                    </div>&nbsp;
                    
                </form>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm"
                (click)="d('Cross click');isNewDiverse=false"><i class="fas fa-times"></i>&nbsp;
                Cerrar</button>
            @if(modalHeaderDiverse=='Nuevo Factor'){
            <button type="button" class="btn btn-primary btn-sm"
                (click)="submitDiverseNew();isNewDiverse=false"
                [disabled]="formDiverse.pristine&&!formDiverse.valid||!formDiverse.valid" tabindex="4"><i
                    class="fas fa-save"></i>&nbsp;Guardar</button>
            }
            @if(modalHeaderDiverse=='Modificar Factor'){
            <button type="button" class="btn btn-primary btn-sm"
            [disabled]="formDiverse.pristine||!formDiverse.valid"   (click)="submitDiverseUpdate();isNewDiverse=false"
                 tabindex="4"><i
                    class="fas fa-save"></i>&nbsp;Actualizar</button>
            }
        </div>
    </ng-template>
    <!--end diverse-->